var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 31",
    fill: "#CE2843",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.26 30.2H4.07c-1.323 0-2.53-.709-3.22-1.89-.69-1.181-.69-2.598 0-3.839L13.445 2.09C14.076.91 15.284.2 16.665.2c1.323 0 2.53.71 3.22 1.89l12.596 22.382c.69 1.181.69 2.599 0 3.839-.69 1.181-1.898 1.89-3.221 1.89ZM15.112 3.093 2.517 25.475a1.748 1.748 0 0 0 0 1.831c.346.59.92.945 1.553.945h25.19c.633 0 1.208-.354 1.553-.945.345-.59.345-1.24 0-1.83L18.218 3.092c-.345-.59-.92-.944-1.553-.944-.69.059-1.265.354-1.553.944Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 8.29c1.38 0 2.473 1.24 2.3 2.658l-1.035 8.799c-.058.65-.633 1.181-1.323 1.181-.633 0-1.208-.531-1.323-1.181l-1.035-8.8c-.057-1.417 1.035-2.657 2.416-2.657ZM15.344 25.18c-.345-.354-.518-.826-.518-1.358 0-.531.173-1.004.518-1.358.345-.354.805-.531 1.322-.531.518 0 .978.177 1.323.531.345.354.518.827.518 1.358 0 .532-.173 1.004-.518 1.359-.345.354-.805.531-1.323.531a1.441 1.441 0 0 1-1.322-.531Z"
  })));
};

export default SvgWarning;